import { Megaphone, Radio, Video, BarChart3 } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { InquiryForm } from "@/components/InquiryForm";
import { useSettings } from "@/context/SettingsContext";

const ICONS = [Megaphone, Radio, Video, BarChart3];
const BUDGETS = ["Under $1,000", "$1,000 – $5,000", "$5,000 – $20,000", "$20,000+", "Not sure yet"];

export default function AdvertisePage() {
  const { pages } = useSettings();
  const perks = pages.advertise_perks || [];
  return (
    <div className="min-h-screen flex flex-col" data-testid="advertise-page">
      <Navbar />
      <main className="flex-1 w-full max-w-[1400px] mx-auto px-5 sm:px-8 pt-10 pb-32">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-10 items-start">
          <div>
            <p className="eyebrow mb-3">{pages.advertise_eyebrow || "Partner with the pack"}</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-none" data-testid="advertise-title">{pages.advertise_title || "Advertise with us"}</h1>
            <p className="mt-6 text-slate-300 leading-relaxed max-w-xl" data-testid="advertise-intro">{pages.advertise_intro}</p>
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {perks.map(({ title, text }, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div key={title + i} className="card-surface rounded-2xl p-5 reveal" style={{ animationDelay: `${i * 70}ms` }} data-testid={`advertise-perk-${i}`}>
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#053671] text-sky-300"><Icon size={18} /></span>
                    <h3 className="mt-3 font-display font-bold">{title}</h3>
                    <p className="mt-1 text-sm text-slate-400 leading-relaxed">{text}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <InquiryForm kind="advertise" title={pages.advertise_form_title || "Tell us about your campaign"} testId="advertise"
            fields={[{ id: "company", label: "Company / brand", required: true }, { id: "budget", label: "Approximate budget", options: BUDGETS }, { id: "links", label: "Website", full: true, placeholder: "https://" }]}
            messageLabel="Campaign details" messagePlaceholder="Goals, timing, shows or genres you're interested in…" submitLabel="Submit"
            successText="Our partnerships team will be in touch with rates and availability." />
        </div>
      </main>
      <Footer />
    </div>
  );
}
